"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Inject, Input } from '@angular/core';
import { UI_CONFIG } from '../ui.config';
var PictureComponent = (function () {
    function PictureComponent(uiConfig) {
        this.uiConfig = uiConfig;
    }
    Object.defineProperty(PictureComponent.prototype, "src", {
        set: function (value) {
            this._src = this.uiConfig.assetsBaseUrl + "/" + value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], PictureComponent.prototype, "src", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], PictureComponent.prototype, "alt", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], PictureComponent.prototype, "display", void 0);
    PictureComponent = __decorate([
        Component({
            selector: 'fl-picture',
            template: "\n    <picture class=\"PictureElement\"\n      [attr.data-display]=\"display\">\n      <source [srcset]=\"_src\">\n      <img [src]=\"_src\" [alt]=\"alt\" [attr.data-display]=\"display\" class=\"ImageElement\">\n    </picture>\n  ",
            styleUrls: ['./picture.component.scss'],
        }),
        __param(0, Inject(UI_CONFIG)),
        __metadata("design:paramtypes", [Object])
    ], PictureComponent);
    return PictureComponent;
}());
export { PictureComponent };



// WEBPACK FOOTER //
// picture.component.js